import React from "react";
import { Pencil } from "lucide-react";
import { Button } from "./ui/button";
import DocumentPrintPdfActions from "./DocumentPrintPdfActions";

export default function UnloadingReceiptActions({
  unloadingId,
  label,
  compact = false,
  onEdit,
  canEdit = false,
}) {
  const safeLabel = (label || `unload-${unloadingId}`).replace(/[/\\?%*:|"<>]/g, "-");

  if (compact) {
    return (
      <div className="flex items-center justify-end gap-0.5" onClick={(e) => e.stopPropagation()}>
        <DocumentPrintPdfActions
          printPath={`/unloading/${unloadingId}/receipt/print`}
          pdfPath={`/unloading/${unloadingId}/receipt/pdf`}
          pdfFilename={`unloading-${safeLabel}.pdf`}
          compact
          printTitle="Print unloading slip"
          pdfTitle="Download unloading slip PDF"
          testIdPrefix={`unloading-${unloadingId}`}
          stopPropagation
        />
        {canEdit && onEdit && (
          <Button
            type="button"
            size="icon"
            variant="ghost"
            className="h-8 w-8 shrink-0 text-muted-foreground hover:text-foreground"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
            title="Edit unloading"
            aria-label="Edit unloading"
            data-testid={`edit-unloading-${unloadingId}`}
          >
            <Pencil className="h-4 w-4" />
          </Button>
        )}
      </div>
    );
  }

  return (
    <DocumentPrintPdfActions
      printPath={`/unloading/${unloadingId}/receipt/print`}
      pdfPath={`/unloading/${unloadingId}/receipt/pdf`}
      pdfFilename={`unloading-${safeLabel}.pdf`}
      printLabel="Print slip"
      pdfLabel="Download PDF"
      printTitle="Print unloading slip"
      pdfTitle="Download unloading slip PDF"
      testIdPrefix={`unloading-${unloadingId}`}
    />
  );
}
